import { NavLink, useLocation } from "react-router-dom";
import { House, Pulse, Butterfly, Camera, User } from "@phosphor-icons/react";

// Mobile-only bottom navigation. Hidden on md+ where the top nav is preferred.
// Uses safe-area insets so the pill sits above the iOS home indicator, and
// includes a data-testid on each item + on the tray for smoke testing.

const ITEMS = [
  { to: "/",             label: "Home",    Icon: House,     end: true,  testid: "bottomnav-home" },
  { to: "/pulse",        label: "Pulse",   Icon: Pulse,                testid: "bottomnav-pulse" },
  { to: "/nature-museum",label: "Museum",  Icon: Butterfly,            testid: "bottomnav-museum" },
  { to: "/photopulse",   label: "Photos",  Icon: Camera,               testid: "bottomnav-photos" },
  { to: "/dashboard",    label: "Profile", Icon: User,                 testid: "bottomnav-profile" },
];

export default function BottomNav() {
  const { pathname } = useLocation();
  // hide on admin (dense chrome), on the callback pages, and on the finish-signin flow
  if (pathname.startsWith("/admin") || pathname.startsWith("/auth/") || pathname.startsWith("/finish-signin")) return null;

  return (
    <>
      {/* Spacer that keeps content from being hidden under the bar */}
      <div className="md:hidden" aria-hidden="true" style={{ height: "calc(64px + env(safe-area-inset-bottom, 0px))" }} />
      <nav
        data-testid="bottom-nav"
        className="md:hidden fixed left-0 right-0 bottom-0 z-40 border-t border-black/10 bg-[color:var(--np-bg,#F5EBDC)]/85 backdrop-blur-xl"
        style={{ paddingBottom: "env(safe-area-inset-bottom, 0px)" }}
      >
        <ul className="grid grid-cols-5 h-16">
          {ITEMS.map(({ to, label, Icon, end, testid }) => (
            <li key={to} className="flex">
              <NavLink
                to={to}
                end={end}
                data-testid={testid}
                className={({ isActive }) =>
                  `flex-1 flex flex-col items-center justify-center gap-1 py-1 relative ${
                    isActive ? "text-[color:var(--np-brand,#B85F2A)]" : "text-[color:var(--np-text-2,#3A3830)]/70 active:text-[color:var(--np-text,#1B4332)]"
                  }`
                }
              >
                {({ isActive }) => (
                  <>
                    {isActive && (
                      <span
                        aria-hidden="true"
                        className="absolute top-0 h-[3px] w-8 rounded-b-full bg-[color:var(--np-brand,#B85F2A)]"
                      />
                    )}
                    <Icon size={22} weight={isActive ? "fill" : "regular"} />
                    <span className="font-mono-tech text-[9px] tracking-[0.16em] uppercase">{label}</span>
                  </>
                )}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
    </>
  );
}
